<template>
    <NuxtLink :to="$withLocalePrefix(data.url)">
        <div class="barometer-home__price">
            <div class="barometer-home__price__image">
                <MaltImg :src="`/families/thumb/${data.thumbnailName}`" quality="90" width="400" :alt="data.family" />
            </div>
            <div class="barometer-home__price__content">
                <!-- <img class="barometer-home__price__picto" src="`~/assets/svg/barometer/developers_datascientists.svg" /> -->
                <div class="barometer-home__price__title">
                    {{ data.family }}
                </div>
                <div class="barometer-home__price__price">
                    <strong>{{ formatPrice(data.price) }}</strong>
                    <span v-html="t('barometer.price.categories.price.label')" />
                </div>
                <div class="barometer-home__price__footer">
                    <VJoyButton class="barometer-home__price__button" variant="ghost" size="small">
                        {{ t('barometer.price.categories.cta') }}
                    </VJoyButton>
                </div>
            </div>
        </div>
    </NuxtLink>
</template>

<script setup lang="ts">
    import {inject} from 'vue';
    import {MaltImg} from '#components';
    import {useTranslation} from '#imports';
    import {VJoyButton} from '@maltjoy/core-vue';
    import {currenciesHelper} from '~/composables/currenciesHelper';
    import {BAROMETER_HOME} from '~/keys';
    import type {FamilyAndPrice} from '~/openapi';

    const {t} = useTranslation();
    const {formatPrice} = currenciesHelper();
    const {generalBarometer} = inject(BAROMETER_HOME)!;

    defineProps<{data: FamilyAndPrice}>();

    const pictoAllowList = ['developers_datascientists'];
</script>

<style lang="scss">
    $hover-translate: calc(var(--joy-core-spacing-2) * -1);

    .barometer-home__price {
        position: relative;
        padding: var(--joy-core-spacing-4);
        border: 1px solid var(--joy-color-neutral-30);
        border-radius: var(--joy-core-radius-2);
        height: 100%;
        overflow: hidden;
        transition:
            transform var(--joy-transition-duration-default) var(--joy-transition-timing-function),
            box-shadow var(--joy-transition-duration-default) var(--joy-transition-timing-function);

        &:hover {
            transform: translate3d(0, $hover-translate, 0);
            box-shadow: var(--joy-core-elevation-3);
        }

        &__image {
            opacity: 0.8;

            &,
            &:after,
            img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
            &::after {
                content: '';
                background-color: black;
                opacity: 0.75;
            }
            img {
                transform-origin: 0 center;
                object-fit: cover;
            }
        }
        &__content {
            position: relative;
            display: flex;
            flex-direction: column;
            height: 100%;
            color: var(--joy-color-neutral-0);
            user-select: none;
        }
        &__picto {
            width: 150px;
            height: 50px;
            margin: var(--joy-core-spacing-8) auto;
        }
        &__title {
            flex: 1;
            // margin-top: var(--joy-core-spacing-2);
            margin-top: 100px;
            margin-bottom: var(--joy-core-spacing-8);
            font-size: var(--joy-font-size-primary-300);
        }
        &__price {
            display: inline-flex;
            gap: var(--joy-core-spacing-2);
            align-items: center;
            justify-content: center;

            strong {
                font-family: var(--joy-font-family-title);
                font-size: var(--joy-font-size-primary-600);
            }
            span {
                text-align: left;
                font-size: var(--joy-font-size-primary-100);
                text-transform: uppercase;
            }
        }
        &__footer {
            margin-top: var(--joy-core-spacing-4);
        }
    }
</style>
